import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  EmployeeHeader,
  FormFieldSet,
  InfoText,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../components";
import { Link, useNavigate } from "react-router-dom";
import EnterPassword from "./Confidential/Modal/EnterPassword";
import { dateFormator } from "../../../../utils";
import { bloodGroupOptions } from "../../../../assets/data/projectData";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { filterEmptyValues } from "../../../../utils/filterEmptyValues";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { addDocumentStart } from "../../../../redux/slices/universal/documentsSlice";
import { uploadStart } from "../../../../redux/slices/universal/fileUploadSlice";
import {
  getEmployeeByUiidStart,
  updateEmployeeStart,
} from "../../../../redux/slices/employee/employeeSlice";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
const confidentialFields = [
  {
    key: "snnDocument",
    title: "SNN Document",
    type: "file",
    placeholder: "Choose file",
  },
  {
    key: "bloodGroup",
    title: "Blood Group",
    type: "select",
    placeholder: "Select Blood Group",
    options: bloodGroupOptions,
  },
  {
    key: "dob",
    title: "Date Of Birth",
    type: "datepicker",
    placeholder: "Select Date Of Birth",
  },
  {
    key: "ssn",
    title: "SSN",
    type: "text",
    placeholder: "Enter SSN Number",
  },
];

const Confidential = () => {
  // debugger;
  const [enterPassword, setEnterPassword] = useState(false); //clickhere modal
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  console.log({ enterPassword, isUnlocked, isEditing });
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { loading, error, employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const navigate = useNavigate();
  const { formData, errors, handleChange, setFormData, validateAllFields } =
    useFormHandler(
      {
        snnDocument: [],
        bloodGroup: "",
        dob: "",
        ssn: "",
      },
      {
        snnDocument: {
          type: "file",
          required: true,
          // allowedFiles: [
          //   { ext: "png", mime: "image/png" },
          //   { ext: "txt", mime: "text/plain" },
          // ],
        },
      },
    );
  console.log("formData", formData);

  const handlePasswordSuccess = () => {
    setIsUnlocked(true);
    setEnterPassword(false);
  };

  const handleEditToggle = () => {
    setIsEditing(true);
  };

  const handleSaveEdit = async () => {
    const isValid = validateAllFields();
    if (isValid) {
      const personalData = {
        ssn: {
          number: formData.ssn,
        },
        dob: formData?.dob,
        bloodType: formData?.bloodGroup,
      };
      const submissionData = filterEmptyValues(personalData);
      const cleanAttachments =
        Array.isArray(formData.snnDocument) && formData.snnDocument.length > 0
          ? formData.snnDocument.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];
      dispatch(
        updateEmployeeStart({
          coll: "Employee",
          uiid: employeeProfileUiid,
          payload: [
            {
              type: "SET",
              value: submissionData,
            },
          ],
          onSuccess: async (payload) => {
            if (cleanAttachments.length > 0) {
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: employeeProfileUiid,
                  entity: "employees",
                  category: "ssn",
                  coll: "Employee",
                  doc: cleanAttachments,
                  onSuccess: (fileData) => {
                    // Step 3: Store document references
                    dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "Employee",
                        refId: employeeProfileUiid,
                        refField: `ssn.document`,
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              addedBy: loginUserUiid,
                              docType: "ssn",
                              parent: { employee: employeeProfileUiid },
                              ref: {
                                id: employeeProfileUiid, // parent doc uiid this doc belongs to
                                entity: "Employee", // collection name this doc belongs to
                                path: `ssn.document`,
                              },
                              file: [
                                { keys: fileData.map((file) => file.key) },
                              ],
                            },
                          ],
                        },
                        onSuccess: (response) => {
                          dispatch(
                            getEmployeeByUiidStart({
                              uiid: employeeProfileUiid,
                              tab: "generalEducation",
                              ret: "firstName middleName lastName jobTitle status email mobile employmentType gender employmentType joinDate location category classification educationDetails managers ssn dob bloodType",
                              ref: "EduDoc",
                            }),
                          );
                          setIsEditing(false);
                        },
                      }),
                    );
                  },
                }),
              );
            }
          },
        }),
      );
    }
  };

  const keyToTitle = (key) => {
    const field = confidentialFields.find((f) => f.key === key);
    return field?.title || key;
  };
  useEffect(() => {
    if (currentEmployee?.employeeDetails) {
      handleChange(
        "bloodGroup",
        currentEmployee.employeeDetails.bloodType ?? "",
      );
      handleChange("dob", currentEmployee.employeeDetails.dob ?? "");
      handleChange("ssn", currentEmployee.employeeDetails.ssn?.number ?? "");
    }
  }, [currentEmployee]);

  return (
    <div className="mt-3 flex-1 flex flex-col gap-2">
      <PageHeader
        Section={<EmployeeHeader />}
        RightSection={
          <div className="flex gap-3">
            <Button
              color="primary"
              size="sm"
              title={"Back"}
              icon={"west"}
              type="link"
              to="/employee"
            />
            {/* <Button
              size="sm"
              title="Back"
              icon={"west"}
              //onClick={() => navigate("/employee/employee-profile#documents")}
              onClick={() =>
                navigate(
                  "/employee/employee-profile?documents=documents&profile-info=documents",
                )
              }
            />
            <Button
              size="sm"
              title="Next"
              icon={"east"}
              iconPosition="after"
              //onClick={() => navigate("/employee/employee-profile#timesheets")}
              onClick={() =>
                navigate(
                  "/employee/employee-profile?profile-info=timesheets&timesheets=timesheets",
                )
              }
            /> */}
          </div>
        }
      />

      <div className="inner-section px-5 py-3">
        <PageHeader
          Section={
            <div className="flex justify-start">
              <PageTitle
                title={
                  !isUnlocked
                    ? "CONFIDENTIAL DETAILS"
                    : isEditing
                      ? "EDIT PERSONAL DETAILS"
                      : "PERSONAL DETAILS"
                }
                icon={
                  !isUnlocked
                    ? "visibility_lock"
                    : isEditing
                      ? "person"
                      : "person"
                }
                tag="h6"
              />
            </div>
          }
          RightSection={
            <>
              {!isUnlocked ? (
                <Button
                  type="icon"
                  variant="text"
                  title="Back"
                  size="sm"
                  icon="close"
                  color="black"
                />
              ) : !isEditing ? (
                <Button
                  variant="contained"
                  title="Edit"
                  icon="edit"
                  size="sm"
                  onClick={handleEditToggle}
                />
              ) : null}
            </>
          }
        />

        <div className="bodytwo mt-1">
          <Divider />
          <div className="mt-5 mb-14">
            {!isUnlocked ? (
              <>
                Please
                <span
                  className="text-info mx-1"
                  onClick={() => setEnterPassword(true)}
                >
                  Click Here
                </span>
                to enter password to view Confidential Information
              </>
            ) : isEditing ? (
              <>
                <div className="grid grid-cols-3 gap-x-8 gap-y-6 max-w-7xl">
                  {confidentialFields.map(
                    ({ key, title, type, placeholder, options }) => (
                      <FormFieldSet
                        key={key}
                        title={title}
                        type={type}
                        options={options}
                        placeholder={placeholder}
                        value={formData[key]}
                        onChange={(val) => handleChange(key, val)}
                        error={errors[key]}
                      />
                    ),
                  )}
                </div>
                <div className="flex mt-2 gap-2">
                  <Button
                    title={"Save"}
                    onClick={() => {
                      if (isUnlocked && isEditing) {
                        handleSaveEdit();
                      }
                    }}
                  />
                  <Button
                    title={"Cancel"}
                    onClick={() => setIsEditing(false)}
                  />
                </div>
              </>
            ) : (
              <div className="grid grid-cols-3 gap-x-8 gap-y-6">
                {Object.keys(formData).map((key) => {
                  const value = formData[key];
                  // const isDateValue = key === "dob";
                  return (
                    <InfoText
                      key={key}
                      size="sm"
                      title={keyToTitle(key)}
                      value={
                        key === "snnDocument"
                          ? Array.isArray(value) && value.length > 0
                            ? value[0].name
                            : "--"
                          : key === "dob"
                            ? dateFormator(value, "month-day-year")
                            : value || "--"
                      }
                    />
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      {enterPassword && (
        <EnterPassword
          isOpen={enterPassword}
          onClose={() => setEnterPassword(false)}
          onSuccess={() => handlePasswordSuccess()}
          loginUserData={loginUserData}
        />
      )}
    </div>
  );
};

export default Confidential;
